// Shared trigger styling for PLP toolbar buttons (Filter + Sort).
// Forces typography + cursor consistency across the two triggers.
// Matches live HSA prod: Grotesque 16/* font-light blue-04 + cursor-pointer.
export const toolbarTriggerClass =
  "flex cursor-pointer items-center gap-1 py-3 font-grotesque text-base font-light text-blue-04";

// Pixel size for trigger icons. SFRA prod uses 24×23 (icon-filter.svg) and
// 24-25 (sort-arrow). Composable Lucide defaults to 24. Use 24 for parity.
export const TOOLBAR_ICON_SIZE = 24;
